import { FormField, SearchField } from '@/components/custom/erp';
import { accountSearchColumns, QUERY_KEYS } from '@/constants';
import type { TaiKhoan } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoProps {
  account: TaiKhoan | null;
  setAccount: (account: TaiKhoan | null) => void;
}

const BasicInfo: React.FC<BasicInfoProps> = ({ account, setAccount }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Tài khoản:</Label>
          <SearchField<TaiKhoan>
            searchColumns={accountSearchColumns}
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
            columnDisplay='code'
            displayRelatedField='name'
            onRowSelection={setAccount}
            value={account?.code || ''}
            relatedFieldValue={account?.name || ''}
          />
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Ngày từ/đến:</Label>
          <FormField name='ngay_ct2' type='date' className='w-48' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
